import { FC, useCallback, useState } from 'react';
import { Container } from '../styles/BasePageLayout';
import styled from 'styled-components';
import {
	BodyMediumTekst,
	BodyStorTekst,
	TittelLitenTekst,
	TittelStorTekst,
} from '../components/atoms/TekstKomponenter.ts';
import PrimaryButton from '../components/atoms/Knapper/PrimaryButton.tsx';
import { Urls } from '../lib/Urls.ts';
import { Spacing } from '../styles/spacing.ts';
import SvgGetter from '../components/atoms/SVG/SvgGetter/SvgGetter.tsx';
import { Footer } from '../components/atoms/Footer.tsx';
import { Colors } from '../styles/colors.ts';
import { useRouter } from 'next/router';

export const Index: FC = () => {
	const router = useRouter();
	const [routerIsLoading, setRouterIsLoading] = useState(false);

	const handleGoToDimensjoneringsMetode = useCallback(() => {
		setRouterIsLoading(true);
		router
			.push(Urls.velgdimensjoneringsmetode)
			.then(() => setRouterIsLoading(false))
			.catch(() => setRouterIsLoading(false));
	}, [router]);

	return (
		<>
			<StyledContainer>
				<InformationContainer>
					<Banner>
						<Kolonne>
							<StyledSvgGetter icon='SvvLogo' wrapSvg />
							<TittelStorTekst>Velkommen til VegDim</TittelStorTekst>
							<BodyStorTekst>
								Vegvesenets system for dimensjonering av nye veger i henhold til N200 Vegbygging.
							</BodyStorTekst>
							<PrimaryButton
								width='min-content'
								tekst='Start dimensjonering'
								loading={routerIsLoading}
								onClick={handleGoToDimensjoneringsMetode}
							/>
						</Kolonne>
						<WelcomImg src='img.png' />
					</Banner>
					<Description>
						<HowHelpImg src='Utviklingsplan.png' />
						<DescriptionContent>
							<Tittel>Hva er VegDim i dag?</Tittel>
							<StyledBodyMediumTekst>
								I dag er VegDim et kontrollverktøy som kan brukes når man dimensjonerer nye
								vegoverbygninger. Man kan bruke verktøyet for å verifisere at vegoverbygningene er
								utformet i henhold til de viktigste skal-kravene i N200. Verktøyet tydeliggjør
								eventuelle avvik og viser hvordan man går fram for å tilfredsstille kravene.
							</StyledBodyMediumTekst>
							<Tittel>Hva er VegDim i framtiden?</Tittel>
							<BodyMediumTekst>
								Framover utvikler vi VegDim til å bli et mekanistisk-empirisk dimensjonerings- og
								analyseverktøy for nye vegoverbygninger. Man skal kunne bruke verktøyet for å hente
								ut prognoser for sporutvikling, utmatting, piggdekkslitasje og telehiv for gitte
								vegoverbygninger. Prognosene for tilstandsutvikling bygger videre fra ERAPave PP
								(utviklet av VTI)
							</BodyMediumTekst>
						</DescriptionContent>
					</Description>
				</InformationContainer>
				<StyledFooter />
			</StyledContainer>
		</>
	);
};

export default Index;

const Banner = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
	@media (max-width: 1100px) {
		grid-template-columns: 1fr;
		row-gap: ${Spacing.sevenXl};
	}
`;

const InformationContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const Description = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
	width: 100%;
	margin-top: ${Spacing.sevenXl};
	background-color: white;
	border-radius: 0.5rem;
	@media (max-width: 1100px) {
		grid-template-columns: 1fr;
	}
`;

const DescriptionContent = styled.div`
	padding: ${Spacing.fiveXl} ${Spacing.fiveXl} ${Spacing.sevenXl};
	@media (max-width: 1100px) {
		padding: ${Spacing.xl} ${Spacing.md} ${Spacing.xxl};
	}
`;

const Kolonne = styled.div`
	display: flex;
	flex-direction: column;
	flex-basis: 40%;

	${TittelStorTekst} {
		margin: ${Spacing.xxl} 0 ${Spacing.lg};
	}

	${BodyStorTekst} {
		margin-bottom: ${Spacing.fiveXl};
	}

	padding: 0 ${Spacing.threeXl} 0 ${Spacing.xl};
	@media (max-width: 1100px) {
		padding: 0;
	}
`;

const WelcomImg = styled.img`
	border-radius: 0.5rem;
	height: 27.5rem;
	object-fit: cover;
`;

const HowHelpImg = styled.img`
	border-radius: 0.5rem 0 0 0.5rem;
	height: 100%;
	object-fit: scale-down;
	background-color: ${Colors.information.background};
`;

const StyledContainer = styled(Container)`
	padding: ${Spacing.elevenXl} ${Spacing.elevenXl} 0;
	@media (max-width: 1100px) {
		padding: ${Spacing.xl} ${Spacing.lg} 0;
	}
	justify-content: space-between;
`;

const Tittel = styled(TittelLitenTekst)`
	margin-bottom: ${Spacing.md};
`;

const StyledSvgGetter = styled(SvgGetter)`
	height: 3.875rem;
	width: 7.375rem;
	@media (max-width: 1100px) {
		align-self: end;
	}
`;

const StyledFooter = styled(Footer)`
	position: relative;
	width: 100%;
	margin-top: ${Spacing.elevenXl};
`;

const StyledBodyMediumTekst = styled(BodyMediumTekst)`
	margin-bottom: ${Spacing.xxl};
	@media (max-width: 1100px) {
		margin-bottom: ${Spacing.xl};
	}
`;
